module.exports = __webpack_public_path__ + "img/icon-white-50.74306d74.svg";